"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSessionStorage = exports.getSessionStorage = exports.getSessionStorageKeys = exports.setLocalStorage = exports.getLocalStorage = exports.getLocalStorageKeys = void 0;
const _1 = require(".");
const getStorageKeys = (type) => Object.keys(type === "localStorage" ? localStorage : sessionStorage);
const getStorage = (type, context, name) => {
    const storage = type === "localStorage" ? localStorage : sessionStorage;
    try {
        if (!context) {
            console.error(`${type}: context is required`);
        }
        if (!name) {
            console.error(`${type}: name is required`);
        }
        const serializedData = storage.getItem(`${context}-${name}`);
        return !serializedData || ["undefined", "null"].includes(serializedData)
            ? null
            : JSON.parse(serializedData);
    }
    catch (error) {
        console.error(`Couldn't get from ${type}`, error); // eslint-disable-line no-console
        return null;
    }
};
const setStorage = async (type, context, name, payload, removeOnMissingConsent = false) => {
    const storage = type === "localStorage" ? localStorage : sessionStorage;
    try {
        if (!context) {
            console.error(`${type}: context is required`);
            return false;
        }
        if (!name) {
            console.error(`${type}: name is required`);
            return false;
        }
        const item = `${context}-${name}`;
        const canSetValue = await _1.CookieConsent.canSetValue(item);
        if (!canSetValue) {
            if (removeOnMissingConsent) {
                storage.removeItem(item);
            }
            return false;
        }
        const serializedData = JSON.stringify(payload);
        storage.setItem(item, serializedData);
        return true;
    }
    catch (error) {
        console.error(`Couldn\t save to ${storage}.`, error); // eslint-disable-line no-console
        return false;
    }
};
// Local storage helpers
const getLocalStorageKeys = () => getStorageKeys("localStorage");
exports.getLocalStorageKeys = getLocalStorageKeys;
const getLocalStorage = (context, name) => getStorage("localStorage", context, name);
exports.getLocalStorage = getLocalStorage;
const setLocalStorage = (context, name, payload, removeOnMissingConsent = false) => setStorage("localStorage", context, name, payload, removeOnMissingConsent);
exports.setLocalStorage = setLocalStorage;
// Session storage helpers
const getSessionStorageKeys = () => getStorageKeys("sessionStorage");
exports.getSessionStorageKeys = getSessionStorageKeys;
const getSessionStorage = (context, name) => getStorage("sessionStorage", context, name);
exports.getSessionStorage = getSessionStorage;
const setSessionStorage = (context, name, payload, removeOnMissingConsent = false) => setStorage("sessionStorage", context, name, payload, removeOnMissingConsent);
exports.setSessionStorage = setSessionStorage;
//# sourceMappingURL=storage.js.map